module.exports = __webpack_public_path__ + "static/img/zuo2.4ed41c09.png";